import { amplitudeLib } from 'freedom-shared';

export const mainTabClicked = (source: string) => {
  amplitudeLib.logEvent('avfree_main_tab_clicked', { source });
};

export const favoritesTabClicked = (source: string) => {
  amplitudeLib.logEvent('avfree_favorites_tab_clicked', { source });
};

export const ordersTabClicked = (source: string) => {
  amplitudeLib.logEvent('avfree_orders_tab_clicked', { source });
};

export const profileTabClicked = (source: string) => {
  amplitudeLib.logEvent('avfree_profile_tab_clicked', { source });
};
